export { default } from "./RepeatingRuleText";
